import React from 'react';

import Image from '../../library/image/image';

import './stopping-distance-chart.scss';

interface SnowStoppingDistanceChartProps {
  bottomOffset?: number;
  className?: string;
  renderTicks?: (
    value: number,
    scaleMax: number,
    scaleMin: number
  ) => React.ReactElement;
  scaleMax: number;
  scaleMin: number;
  value: number;
}

function StoppingDistanceChart(props: SnowStoppingDistanceChartProps) {
  const {
    bottomOffset = 0,
    className = '',
    renderTicks,
    scaleMax,
    scaleMin,
    value: valueProp
  } = props;
  const value = Math.min(scaleMax, valueProp);
  const carOffset = Math.floor(
    ((value - scaleMin) / (scaleMax - scaleMin)) * 100
  );
  const leftEndpointOffset = carOffset === 100 ? 25 : 16;

  return (
    <div
      className={`stopping-distance-chart ${className}`}
      styleName="container"
    >
      {renderTicks?.(value, scaleMax, scaleMin)}
      <div
        className="stopping-distance-chart__empty"
        style={{ bottom: bottomOffset + 8 }}
        styleName="empty"
      />
      <div
        className="stopping-distance-chart__fill"
        style={{ bottom: bottomOffset + 8, width: `${carOffset}%` }}
        styleName="fill"
      />
      <span
        style={{
          bottom: bottomOffset + 6,
          left: `calc(${carOffset}% - ${leftEndpointOffset}px)`
        }}
        styleName="value-marker"
      >
        <span style={{ bottom: bottomOffset + 21 }} styleName="value">
          {value}&apos;
        </span>
        <Image
          alt="Car Image"
          src="https://discounttire.scene7.com/is/image/discounttire/ic_car?fmt=png-alpha"
          styleName="car-image"
        />
      </span>
    </div>
  );
}

export default StoppingDistanceChart;
